import { Injectable } from "@angular/core";
import {
    MCAuthoritiesEventsEnvironment
} from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsEnvironment extends MCAuthoritiesEventsEnvironment {


}
